module.exports = __webpack_public_path__ + "b646a6e84f571dd51a65827de5ebb620.svg";